import { Component } from '@angular/core';
import { LazyLoadScriptService } from './lazy_load_script_service';
import {TranslateService} from "@ngx-translate/core";
import * as $ from 'jquery';
declare function OneHr();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private lazyLoadService: LazyLoadScriptService, private translate: TranslateService) { 
    translate.setDefaultLang('en');
    translate.use('en');
  }
  title = 'onehrSite';

  ngOnInit() {
    $(document).ready(function () {
      $("button").click(function () {
        var div = $("div");
        /* (NOT SURE FOR WHAT PURPOSE THIS CODE SET IS WRITTEN) */
        // div.animate({ left: '100px' }, "slow");
        // div.animate({ fontSize: '5em' }, "slow");
        /* COMMENTED FOR THE PURPOSE - ALIGNMENT MISMATCH IN FIREFOX & EDGE */
      });
    });
    
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {
      OneHr();
    });
  }
}
